import React from 'react';
import { getUrl } from 'utils/corploansUrl';
import { plural } from 'utils/plural';
import DOMPurify from 'dompurify';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
      isExpressEnergyOffer= window.location.href.includes('express_energy'),
      phraseArray = ['CALCULATOR_FULL_MONTHS_02', 'CALCULATOR_FULL_MONTHS_01','CALCULATOR_FULL_MONTHS'];


    return (
        <React.Fragment>
            <div className={`loan-conditions-table`}>
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW')}</div>
                    <div className="condition-text">{model.getRequiredPayment().toLocaleString('RU-ru', {minimumFractionDigits: 2,
                        maximumFractionDigits: 2})} {calc.l10n('UAH_ICON')}</div>
                </div>
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_SUM')}</div>
                    <div className="condition-text">{model.getCreditSum().toLocaleString('RU-ru', {minimumFractionDigits: 2,
                        maximumFractionDigits: 2})} {calc.l10n('UAH_ICON')}</div>
                </div>
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_OVERPAYMENT_AEXPRESS')}</div>
                    <div className="condition-text">{model.getOverpayment().toLocaleString('RU-ru', {minimumFractionDigits: 2,
                        maximumFractionDigits: 2})} {calc.l10n('UAH_ICON')}</div>
                </div>
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_TERM')}</div>
                    <div className="condition-text">{model.getCurrentTerm().toLocaleString()} {calc.l10n(`${plural(model.getCurrentTerm(), phraseArray )}`)}</div>
                </div>
            </div>
            <div className="loan-conditions-lines">
                {
                    isExpressEnergyOffer ?
                      (
                        <div className="loan-conditions-item">
                            <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_ONE_TIME_COMMISSION')}</div>
                            <div className="condition-text">{calc.l10n('CREDIT_FEATURE_PP_COMMISSION')}</div>
                        </div>
                      )
                      :
                      ''
                }
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_COMMISSION')}</div>
                    <div className="condition-text">{model.getMonthCommission().toLocaleString('RU-ru')} %</div>
                </div>
                <div className="loan-conditions-item">
                    <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_BID')}</div>
                    <div className="condition-text">{model.getCreditRate().toLocaleString('RU-ru')} %</div>
                </div>
                <button className='loan-order-btn' onClick={() => window.open(getUrl())}>{calc.l10n('SEND_APPLICATION')}</button>
                <div className="disclaimer" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(calc.l10n('CALCULATOR_DISCLAIMER_NEW_2'))}}></div>
            </div>
        </React.Fragment>
    );
}
